import { render } from "./ApprovedBills.vue?vue&type=template&id=7ab3077c&scoped=true"
import script from "./ApprovedBills.vue?vue&type=script&lang=js"
export * from "./ApprovedBills.vue?vue&type=script&lang=js"

import "./ApprovedBills.vue?vue&type=style&index=0&id=7ab3077c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ab3077c"]])

export default __exports__